import { jsDateToTimeString, timeStringToJsDate } from "@/utils/date-time";
import { LatLng, PaginationFilterRequest, UpsertLatLng } from "./core.model";

export type SpecificType = CountryTypeStoryChapterTask | CityTypeStoryChapterTask | AreaTypeStoryChapterTask | TimeTypeStoryChapterTask | SpecificStartEndTypeStoryChapterTask | RunClubTypeStoryChapterTask | undefined;
export type UpsertSpecificType = UpsertCountryTypeStoryChapterTask | UpsertCityTypeStoryChapterTask | UpsertAreaTypeStoryChapterTask | UpsertTimeTypeStoryChapterTask | UpsertSpecificStartEndTypeStoryChapterTask | UpsertRunClubTypeStoryChapterTask | undefined;

export function storyChapterTaskFromJson (json: any) {

  if(json.type == StoryChapterTaskTypeEnum.Time){
    return {
      ...json,
      startTime: timeStringToJsDate(json.startTime),
      endTime: timeStringToJsDate(json.endTime)
    } as StoryChapterTask&SpecificType;
  }
  return json;
};

export function jsonFromStoryChapterTask (task: UpsertStoryChapterTask&UpsertSpecificType) {
  if(task.type == StoryChapterTaskTypeEnum.Time){
    return {
      ...task,
      startTime: jsDateToTimeString((task as UpsertTimeTypeStoryChapterTask).startTime!),
      endTime: jsDateToTimeString((task as UpsertTimeTypeStoryChapterTask).endTime!),
    };
  }
  return task;
};

export interface StoryChapterTask {
  id: number;
  type: StoryChapterTaskTypeEnum;
  name: string;
  order: number;
  firstLevelAmount: number;
  secondLevelAmount?: number;
  thirdLevelAmount?: number;
  chapterId: number;
  calculationType: StoryChapterTaskCalculationTypeEnum
}

export interface UpsertStoryChapterTask {
  id?: number;
  type?: StoryChapterTaskTypeEnum;
  name?: string;
  order?: number;
  firstLevelAmount?: number;
  secondLevelAmount?: number;
  thirdLevelAmount?: number;
  chapterId?: number;
  calculationType?: StoryChapterTaskCalculationTypeEnum
}

export class StoryChapterTaskPaginationFilterRequest extends PaginationFilterRequest{  
    chapterId?: number;
    type?: StoryChapterTaskTypeEnum;
}

export enum StoryChapterTaskCalculationTypeEnum
{
    Sum = 1,
    Max = 2,
    Min = 3
}
export const StoryChapterTaskCalculationTypeList = [
  {value:1, label:"Sum"},
  {value:2, label:"Maximum"},
  {value:3, label:"Minimum"},
];

export enum StoryChapterTaskTypeEnum {
  Area = 1,
  Country = 2,
  City = 3,
  Distance = 5,
  Time = 7,
  Elevation = 8,
  SpecificStartEnd = 11,
  RunClub = 12,
}

export const StoryChapterTaskTypeInfo : Record<StoryChapterTaskTypeEnum, {value:number, label:string, amountUnit:string}> = {
  [StoryChapterTaskTypeEnum.Area]: {value:1, label:"Area", amountUnit: "Meter"},
  [StoryChapterTaskTypeEnum.Country]: {value:2, label:"Country", amountUnit: "Meter"},
  [StoryChapterTaskTypeEnum.City]: {value:3, label:"City", amountUnit: "Meter"},
  [StoryChapterTaskTypeEnum.Distance]: {value:5, label:"Distance", amountUnit: "Meter"},
  [StoryChapterTaskTypeEnum.Time]: {value:7, label:"Time", amountUnit: "Minute"},
  [StoryChapterTaskTypeEnum.Elevation]: {value:8, label:"Elevation Gain", amountUnit: "Meter"},
  [StoryChapterTaskTypeEnum.SpecificStartEnd]: {value:11, label:"Specific Start & End", amountUnit: "Minute"},
  [StoryChapterTaskTypeEnum.RunClub]: {value:12, label:"Run Club", amountUnit: "Club Count"},
};

export const getMainPart = (task: StoryChapterTask&SpecificType) : StoryChapterTask => {
  return {
    id: task.id,
    name: task.name,
    type: task.type,
    order: task.order,
    firstLevelAmount: task.firstLevelAmount,
    secondLevelAmount: task.secondLevelAmount,
    thirdLevelAmount: task.thirdLevelAmount,
    chapterId: task.chapterId,
    calculationType: task.calculationType,
  };
};
export const getSpecificPart = (task: StoryChapterTask&SpecificType) : SpecificType => {
  switch (task.type){
    case StoryChapterTaskTypeEnum.Area :
      return {
        jsonArea: (task as AreaTypeStoryChapterTask).jsonArea,
      };
    case StoryChapterTaskTypeEnum.Country :
      return {
        countryId: (task as CountryTypeStoryChapterTask).countryId,
      };
    case StoryChapterTaskTypeEnum.City :
      return {
        cityId: (task as CityTypeStoryChapterTask).cityId
      };
    case StoryChapterTaskTypeEnum.Time :
      return {
        startTime: (task as TimeTypeStoryChapterTask).startTime,
        endTime: (task as TimeTypeStoryChapterTask).endTime,
      };
    case StoryChapterTaskTypeEnum.SpecificStartEnd :
      return {
        startPoint: (task as SpecificStartEndTypeStoryChapterTask).startPoint,
        endPoint: (task as SpecificStartEndTypeStoryChapterTask).endPoint,
      };
    case StoryChapterTaskTypeEnum.RunClub :
      return {
        runClubIds: (task as RunClubTypeStoryChapterTask).runClubIds,
      };
    default: 
      return undefined;
  }
};


export interface AreaTypeStoryChapterTask {
  jsonArea: string;
}
export interface UpsertAreaTypeStoryChapterTask {
  jsonArea?: string;
}

export interface CountryTypeStoryChapterTask {
  countryId: number;
}
export interface UpsertCountryTypeStoryChapterTask {
  countryId?: number;
}

export interface CityTypeStoryChapterTask {
  cityId: number;
}
export interface UpsertCityTypeStoryChapterTask {
  cityId?: number;
}

export interface TimeTypeStoryChapterTask {
  startTime: Date;
  endTime: Date;
}
export interface UpsertTimeTypeStoryChapterTask {
  startTime?: Date;
  endTime?: Date;
}

export interface SpecificStartEndTypeStoryChapterTask {
  startPoint: LatLng;
  endPoint: LatLng;
}
export interface UpsertSpecificStartEndTypeStoryChapterTask {
  startPoint?: UpsertLatLng;
  endPoint?: UpsertLatLng;
}

export interface RunClubTypeStoryChapterTask {
  runClubIds?: number[];
}
export interface UpsertRunClubTypeStoryChapterTask {
  runClubIds?: number[];
}
